import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';

export interface Vehicles {
  img: string;
  name: string;
}

@Component({
  selector: 'app-for-who',
  templateUrl: './for-who.component.html',
  styleUrls: ['./for-who.component.scss'],
})
export class ForWhoComponent implements OnInit {
  vehicles: Vehicles[];

  onPath(path: string): boolean {
    return this.router.url.split('?')[0].split('#')[0] === path;
  }
  /** False during SSG so prerender HTML does not discover 9 vehicle image URLs. */
  showVehicles = false;

  constructor(
    private transloco: TranslocoService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.vehicles = [
      {
        img: '08_Mercedes_Suv.jpg',
        name: this.transloco.translate('home.for-who.vehicle.1'),
      },
      {
        img: '09_Mercedes_Van.jpg',
        name: this.transloco.translate('home.for-who.vehicle.2'),
      },
      {
        img: '10_TIR.jpg',
        name: this.transloco.translate('home.for-who.vehicle.3'),
      },
      {
        img: '11_Motocykl.jpg',
        name: this.transloco.translate('home.for-who.vehicle.4'),
      },
      {
        img: '12_Kamper.jpg',
        name: this.transloco.translate('home.for-who.vehicle.5'),
      },
      {
        img: '13_Mustang.jpg',
        name: this.transloco.translate('home.for-who.vehicle.6'),
      },
      {
        img: '14_Autobus.jpg',
        name: this.transloco.translate('home.for-who.vehicle.7'),
      },
      {
        img: '15_traktor.jpg',
        name: this.transloco.translate('home.for-who.vehicle.8'),
      },
      {
        img: '16_Przyczepa.jpg',
        name: this.transloco.translate('home.for-who.vehicle.9'),
      },
    ];
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      // Defer past first paint / hydration so critical path stays free.
      const win = window as Window & {
        requestIdleCallback?: (cb: () => void) => number;
      };
      if (typeof win.requestIdleCallback === 'function') {
        win.requestIdleCallback(() => {
          this.showVehicles = true;
        });
      } else {
        setTimeout(() => {
          this.showVehicles = true;
        }, 0);
      }
    }
  }
}
